module.exports = __webpack_public_path__ + "assets/images/mirror-03.16e2e6e13f0988484c9d2353c0f2c5c8.svg";